// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
            `,
            /* Store Custom Code - Start */
            tooltipBody: css`
                padding: ${pxToRem(10, 12)};
                background-color: ${getColor("text")};
                box-shadow: ${x => x.theme.shadows.e60};
                text-transform: none;
            `,
            tooltipArrow: css`
                border-color: ${getColor("text")} transparent transparent transparent;
            `,
            /* Store Custom Code - End */
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
